import { Routes } from '@angular/router';
import { CivicBudgetPageComponent } from './civic-budget-page.component';
import {
  CivicBudgetSubmitProjectPageComponent
} from './containers/civic-budget-submit-project-page/civic-budget-submit-project-page.component';
import { AuthGuard } from '../../guards/auth.guard';
import { IsCompletedUserDataGuard } from '../../guards/is-completed-user-data.guard';
import {
  CivicBudgetDetailsPageComponent
} from './containers/civic-budget-details-page/civic-budget-details-page.component';

export const civicBudgetRoutes: Routes = [
  {
    component: CivicBudgetPageComponent,
    path: 'budzet-obywatelski',
    pathMatch: 'full'
  },
  {
    component: CivicBudgetDetailsPageComponent,
    path: 'budzet-obywatelski/:id',
    pathMatch: 'full'
  },
  {
    component: CivicBudgetSubmitProjectPageComponent,
    path: 'budzet-obywatelski/:id/zglos',
    pathMatch: 'full',
    canActivate: [AuthGuard, IsCompletedUserDataGuard]
  }
];
